import { ReactNode } from 'react'

const TemplatesListSkeleton = (): ReactNode => (
  <div className="grid h-fit w-full grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-8 xl:grid-cols-3 xl:gap-8">
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
  </div>
)

const SkeletonItem = (): ReactNode => (
  <div className="flex h-fit animate-pulse flex-col overflow-x-hidden rounded-lg shadow-xl">
    <div className="group relative">
      <div className="h-[200px] rounded-t-md bg-skeleton-primary text-transparent lg:min-w-[300px]">
        .
      </div>
    </div>
    <div className="flex flex-col gap-3 px-5 py-6">
      <span className="rounded-md bg-skeleton-primary text-transparent">.</span>
      <ul className="flex flex-wrap gap-1.5">
        <li className="grow rounded-md bg-skeleton-primary py-1 text-transparent">.</li>
        <li className="grow rounded-md bg-skeleton-primary py-1 text-transparent">.</li>
        <li className="grow rounded-md bg-skeleton-primary py-1 text-transparent">.</li>
      </ul>
    </div>
  </div>
)

export default TemplatesListSkeleton
